const ServicesCard = (props) => {
  return (
    <div className="z-10 rounded-xl p-[2px] bg-gradient-to-r from-accent via-[#1C8D8E] to-[#2A5E6F] hover:scale-105 duration-200 overflow-hidden w-full opacity-50 hover:opacity-100 brightness-110 background-animate">
      <span className="block text-m text-white rounded-xl bg-bg-primary overflow-hidden h-full">
        <div className="w-full h-full flex flex-col justify-center items-center p-10">
          <div className="h-1/3">
            <img
              className="object-cover w-24"
              src={props.src}
              alt="img"
              loading="lazy"
              object-fit="fill"
            ></img>
          </div>
          <div className="text-center">
            <h1 className="font-bold pb-5">{props.title}</h1>
            <p>{props.text}</p>
          </div>
        </div>
      </span>
    </div>
  );
};

export default ServicesCard;
